import {
  DEFAULT_ORGANIZATION_TIMEZONE,
  dateOnlyInTimezone,
} from "../../../../_shared/_logic/timezones"

export type PlanningLeadTimeSettings =
  | {
      timezone?: string | null
      flex_slots_per_day?: number | null
      appointment_letter_lead_days?: number | null
    }
  | null
  | undefined

/** Date-only fallback; this does not constrain explicitly chosen appointments. */
export const resolveDefaultAppointmentStartDate = (): string =>
  dateOnlyInTimezone(new Date(Date.now() + 24 * 60 * 60 * 1000), DEFAULT_ORGANIZATION_TIMEZONE)

export const resolveDefaultBatchPlanningLeadWeeks = (): number => 2

export const resolveDefaultBatchPlanningLeadDays = (): number =>
  resolveDefaultBatchPlanningLeadWeeks() * 7

export const resolveBatchPlanningStartDateForLeadWeeks = (
  weeks: number,
  now = new Date(),
  timezone = DEFAULT_ORGANIZATION_TIMEZONE,
): string => {
  const normalizedWeeks = Number.isFinite(weeks) ? Math.max(0, Math.floor(weeks)) : 0
  const today = dateOnlyInTimezone(now, timezone)

  if (!today) return ""

  const basis = new Date(`${today}T00:00:00Z`)
  const dayOfWeek = basis.getUTCDay()
  const daysUntilBasisMonday = dayOfWeek === 1 ? 0 : dayOfWeek === 0 ? 1 : 8 - dayOfWeek
  basis.setUTCDate(basis.getUTCDate() + daysUntilBasisMonday + normalizedWeeks * 7)

  return basis.toISOString().slice(0, 10)
}

export const resolveDefaultBatchAppointmentStartDate = (
  settings?: PlanningLeadTimeSettings,
): string =>
  resolveBatchPlanningStartDateForLeadWeeks(
    resolveDefaultBatchPlanningLeadWeeks(),
    new Date(),
    settings?.timezone ?? DEFAULT_ORGANIZATION_TIMEZONE,
  )
